import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, Eye } from "lucide-react";
import { api, asset } from "../lib/api";
import { Logo } from "../components/Logo";
import { Loader } from "../components/ProtectedRoute";

export default function ImageView() {
  const { id } = useParams();
  const [img, setImg] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/images/${id}`).then(({ data }) => setImg(data)).catch(() => setErr(true)); }, [id]);
  if (err) return <div className="flex min-h-screen items-center justify-center bg-[#080808] text-zinc-400" data-testid="image-not-found">image not found.</div>;
  if (!img) return <Loader />;
  const accent = img.owner?.accent_color || "#ff3b91";
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-6 bg-[#080808] px-5 py-14">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-96 w-96 -translate-x-1/2 rounded-full opacity-20 blur-[120px]" style={{ background: accent }} />
      <img data-testid="hosted-image" src={asset(img.url)} alt={img.original_filename} className="relative max-h-[75vh] max-w-full rounded-2xl border border-white/10 object-contain animate-fade-up" style={{ boxShadow: `0 0 60px ${accent}22` }} />
      <div className="relative flex items-center gap-5 font-mono text-xs text-zinc-500">
        <span>uploaded by <a href={`/${img.owner_username}`} className="text-white hover:underline" data-testid="image-owner-link">@{img.owner_username}</a></span>
        <span className="flex items-center gap-1"><Eye className="h-3 w-3" />{img.views}</span>
        <a href={asset(img.url)} download className="flex items-center gap-1 hover:text-white" data-testid="image-download-link"><Download className="h-3 w-3" />raw</a>
      </div>
      <Logo className="relative mt-4 text-sm opacity-60" />
    </div>
  );
}
